
import { Component, Vue } from "vue-property-decorator";
import { format, isAfter } from "date-fns";
import { API_TFile } from "@/models/document_cards";
import { SMDocuments, SMUser } from "@/store";

@Component
export default class ArchivedFiles extends Vue {
  isFiltered: boolean | null = false;

  get documentCard() {
    return SMDocuments.documentCard;
  }

  get documentCardTitle() {
    return SMDocuments.documentCardTitle;
  }

  get archivedUploadedFiles() {
    return SMDocuments.archivedUploadedFiles;
  }

  get canDeleteFile() {
    if (SMUser.isEmployee) return false;

    return true;
  }

  getUploadedBy(file: API_TFile) {
    const data = file.uploaded_by;
    return `${data.first_name} ${data.last_name}`;
  }

  formatDate(value: string) {
    const date = new Date(value);
    const formatStr = "dd/MM/yyyy";
    return format(date, formatStr);
  }

  get filteredArchivedUploadedFiles() {
    const arr = SMDocuments.archivedUploadedFiles.sort((a, b) =>
      isAfter(new Date(a.CreatedAt), new Date(b.CreatedAt)) ? -1 : 1
    );
    if (this.isFiltered) {
      return arr;
    }
    return arr.reverse();
  }

  async downloadFile(file: API_TFile) {
    SMDocuments.setRouteFullPath(this.$route.fullPath);

    const data = await SMDocuments.getFileData(file);

    if (!data) return;

    SMDocuments.downloadFile(data);

    SMDocuments.unsetRouteFullPath();
  }

  async deleteFile(file: API_TFile) {
    const isDeleted = await SMDocuments.deleteFile(file);
    if (isDeleted) {
      this.$emit("update");
    }
  }

  get backLabel() {
    if (this.documentCardTitle) {
      return `Back to ${this.documentCardTitle}`;
    }
    return "Back";
  }

  goBack() {
    this.$router.push(this.$route.path.substr(0, this.$route.path.lastIndexOf("/")));
  }
}
